import React, { useEffect, useState } from "react";
import { Prompt, useHistory } from "react-router-dom";
import { Location } from "history";
import { Grid, Typography } from "@material-ui/core";

import { ModalTemplate } from "../modal-template/modal-template.component";
import { GreenButton } from "../../form-controls/button/green-button/green-button.component";
import { OutlinedButton } from "../../form-controls/button/outlined-button/outlined-button.component";

import { UnsavedChangesModalProps } from "./unsaved-changes-modal.props";
import { useUnsavedChangesModalStyles } from "./unsaved-changes-modal.styles";

export const UnsavedChangesModal = (props: UnsavedChangesModalProps) => {
  const { forceOpen = false, navigate } = props;

  const when = () => {
    if (typeof props.when === "function") {
      return props.when();
    }

    return props.when;
  };

  const classes = useUnsavedChangesModalStyles();
  const history = useHistory();
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const closeModal = () => {
    if (typeof forceOpen === "function") {
      forceOpen(false);
    } else {
      setModalVisible(false);
    }
  };

  const handleBlockedNavigation = (nextLocation: Location): boolean => {
    let shouldBlock: boolean;
    if (props.shouldBlockNavigation) {
      shouldBlock = props.shouldBlockNavigation(nextLocation);
    } else {
      shouldBlock = when();
    }

    if (!confirmedNavigation && shouldBlock) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    if (typeof forceOpen === "function") {
      forceOpen(true);
    } else {
      setModalVisible(false);
      setConfirmedNavigation(true);
    }
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      // Navigate to the previous blocked location with your navigate function
      if (navigate) {
        navigate(lastLocation.pathname);
      } else {
        history.push(lastLocation.pathname);
      }
    }
  }, [confirmedNavigation, history, lastLocation, navigate]);

  return (
    <>
      <Prompt when={when()} message={handleBlockedNavigation} />
      <ModalTemplate
        closeModal={closeModal}
        header={props.modalTitle ?? "Warning: There are unsaved changes on this page"}
        open={modalVisible || Boolean(forceOpen)}
        size="small"
      >
        <Grid item xs={12}>
          <Typography className={classes.message} component="p" variant="h5">
            {props.modalMessage ??
              "Navigating away will result in these changes being lost.\nWould you like to continue?"}
          </Typography>
        </Grid>

        <Grid item xs={12} className="text-right">
          <div className="form-group buttons" style={{ marginTop: "16px" }}>
            <GreenButton type="submit" onClick={closeModal}>
              Back to brief
            </GreenButton>
            <OutlinedButton
              showIf={!props.disabledContinueBtn}
              type="submit"
              onClick={handleConfirmNavigationClick}
            >
              Continue
            </OutlinedButton>
          </div>
        </Grid>
      </ModalTemplate>
    </>
  );
};
